import { atom } from 'jotai';

import type { LatestImageWithOverrides } from '../../../@types/latestImages';

export interface ModelsToggles {
  caries: boolean;
  incipients: boolean;
  periapical_radiolucency: boolean;
  radiographic_boneloss: boolean;
  user: boolean;
  calculus: boolean;
  area_of_concern: boolean;
  restorative_adjacent_lucency: boolean;
}

interface ToothPartsToggle {
  tooth_anatomy: boolean;
}

interface EnabledModels {
  isPrlEnabled: boolean;
  isRblEnabled: boolean;
  isCalculusEnabled: boolean;
  isCariesSubclassEnabled: boolean;
  isVdaEnabled: boolean;
}

// Base models
export const modelsTogglesAtom = atom<ModelsToggles>({
  caries: true,
  incipients: true,
  periapical_radiolucency: false,
  radiographic_boneloss: false,
  user: true,
  calculus: false,
  area_of_concern: false,
  restorative_adjacent_lucency: false,
});
export const enabledModelsAtom = atom<EnabledModels>({
  isPrlEnabled: false,
  isRblEnabled: false,
  isCalculusEnabled: false,
  isCariesSubclassEnabled: false,
  isVdaEnabled: false,
});
export const toothPartsTogglesAtom = atom<ToothPartsToggle>({
  tooth_anatomy: true,
});
export const activeImageIdAtom = atom(undefined);
export const hoveredImageIdAtom = atom(undefined);
export const hoveredFindingIdAtom = atom(undefined);
export const modeAtom = atom<'FMX' | 'BITEWING' | 'Odontogram' | number>('FMX');
export const latestImagesAtom = atom<LatestImageWithOverrides[]>([]);

export const categoriesTogglesAtom = atom(
  (get) => ({
    restorative: !!get(modelsTogglesAtom)?.caries,
    periodontal: !!get(modelsTogglesAtom)?.radiographic_boneloss,
    endodontic: !!get(modelsTogglesAtom)?.periapical_radiolucency,
    chart: !!get(toothPartsTogglesAtom)?.tooth_anatomy,
  }),
  (
    get,
    set,
    toggle: 'restorative' | 'periodontal' | 'endodontic' | 'chart',
  ) => {
    const categoriesToggles = get(categoriesTogglesAtom);
    const enabledModels = get(enabledModelsAtom);
    const modelsToggles = get(modelsTogglesAtom);
    if (toggle === 'restorative') {
      set(modelsTogglesAtom, {
        ...modelsToggles,
        caries: !categoriesToggles.restorative,
        user: !categoriesToggles.restorative,
        area_of_concern:
          !categoriesToggles.restorative &&
          enabledModels.isCariesSubclassEnabled,
        restorative_adjacent_lucency:
          !categoriesToggles.restorative && enabledModels.isVdaEnabled,
      });
    }
    if (toggle === 'periodontal') {
      set(modelsTogglesAtom, {
        ...modelsToggles,
        radiographic_boneloss:
          !categoriesToggles.periodontal && enabledModels.isRblEnabled,
        calculus:
          !categoriesToggles.periodontal && enabledModels.isCalculusEnabled,
      });
    }
    if (toggle === 'endodontic') {
      set(modelsTogglesAtom, {
        ...modelsToggles,
        periapical_radiolucency:
          !categoriesToggles.endodontic && enabledModels.isPrlEnabled,
      });
    }
    if (toggle === 'chart') {
      set(toothPartsTogglesAtom, {
        ...toothPartsTogglesAtom,
        tooth_anatomy: !categoriesToggles.chart,
      });
    }
  },
);
